export const ALL_FROM_CATEGORY_SUFFIX = 'all-from-category'

export const storyAccessorIsAllFromCategoryPath = (slug: string): boolean => {
  const normalized = slug.endsWith('/') ? slug.slice(0, -1) : slug

  return normalized.endsWith(ALL_FROM_CATEGORY_SUFFIX)
}
